import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { printLostTicketSuccessful, printLostTicketFailed } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* printLostTicket(action) {
  try {
    const url = `${BACKEND_URL}/sessions/${action.payload?.id}/print-lost-ticket`;
    const dataResponse = yield makeRequest(url, action.payload?.pool, action, 'POST', true);
    if (dataResponse.status === NO_CONTENT) {
      const data = yield getBodyJson(dataResponse);
      yield put(printLostTicketSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield getBodyJson(dataResponse);
      yield put(printLostTicketFailed(data));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(printLostTicketFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
